
const open_popup = (target, width, height) => {
    var extwindow = window.open(target, "issp_popup", "toolbar=no,status=no,menubar=no,top=100,left=100,width=" + width + ",height=" + height + ",scrollbars,resizable=yes");
    extwindow.focus();
}
